// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListCurrenciesForPerformanceReviewQueryVariables = Types.Exact<{
  performanceReviewId: Types.Scalars['ID']['input'];
}>;

export type ListCurrenciesForPerformanceReviewQuery = { __typename?: 'Query' } & {
  listCurrenciesForPerformanceReview: { __typename?: 'ListCurrencies' } & Pick<Types.ListCurrencies, 'totalCount'> & {
      items: Array<{ __typename?: 'Currency' } & Pick<Types.Currency, 'id' | 'name'>>;
    };
};

export const ListCurrenciesForPerformanceReviewDocument = /*#__PURE__*/ gql`
    query listCurrenciesForPerformanceReview($performanceReviewId: ID!) {
  listCurrenciesForPerformanceReview(performanceReviewId: $performanceReviewId) {
    items {
      id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useListCurrenciesForPerformanceReviewQuery__
 *
 * To run a query within a React component, call `useListCurrenciesForPerformanceReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCurrenciesForPerformanceReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCurrenciesForPerformanceReviewQuery({
 *   variables: {
 *      performanceReviewId: // value for 'performanceReviewId'
 *   },
 * });
 */
export function useListCurrenciesForPerformanceReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCurrenciesForPerformanceReviewQuery,
    ListCurrenciesForPerformanceReviewQueryVariables
  > &
    ({ variables: ListCurrenciesForPerformanceReviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCurrenciesForPerformanceReviewQuery, ListCurrenciesForPerformanceReviewQueryVariables>(
    ListCurrenciesForPerformanceReviewDocument,
    options,
  );
}
export function useListCurrenciesForPerformanceReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCurrenciesForPerformanceReviewQuery,
    ListCurrenciesForPerformanceReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCurrenciesForPerformanceReviewQuery, ListCurrenciesForPerformanceReviewQueryVariables>(
    ListCurrenciesForPerformanceReviewDocument,
    options,
  );
}
// @ts-expect-error
export function useListCurrenciesForPerformanceReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListCurrenciesForPerformanceReviewQuery,
    ListCurrenciesForPerformanceReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListCurrenciesForPerformanceReviewQuery,
  ListCurrenciesForPerformanceReviewQueryVariables
>;
export function useListCurrenciesForPerformanceReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCurrenciesForPerformanceReviewQuery,
        ListCurrenciesForPerformanceReviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListCurrenciesForPerformanceReviewQuery | undefined,
  ListCurrenciesForPerformanceReviewQueryVariables
>;
export function useListCurrenciesForPerformanceReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCurrenciesForPerformanceReviewQuery,
        ListCurrenciesForPerformanceReviewQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListCurrenciesForPerformanceReviewQuery,
    ListCurrenciesForPerformanceReviewQueryVariables
  >(ListCurrenciesForPerformanceReviewDocument, options);
}
export type ListCurrenciesForPerformanceReviewQueryHookResult = ReturnType<
  typeof useListCurrenciesForPerformanceReviewQuery
>;
export type ListCurrenciesForPerformanceReviewLazyQueryHookResult = ReturnType<
  typeof useListCurrenciesForPerformanceReviewLazyQuery
>;
export type ListCurrenciesForPerformanceReviewSuspenseQueryHookResult = ReturnType<
  typeof useListCurrenciesForPerformanceReviewSuspenseQuery
>;
